<template>
  <div :id="componentId" class="sp44-wrapper">
    <div class="sp44-section">
      <!-- Logo 图片区域 -->
      <div class="sp44-logo-wrapper">
        <div ref="logoContainer" class="sp44-logo-container">
          <img
            v-if="data.logoImage"
            class="sp44-logo-image"
            referrerpolicy="no-referrer"
            :src="data.logoImage"
            @load="updateLogoWidth"
          />
        </div>
      </div>

      <!-- 横线 -->
      <div
        class="sp44-divider"
        :style="{
          left: logoWidth + 'px',
          width: 'calc(1400px - ' + logoWidth + 'px - 79px - 48px)'
        }"
      ></div>

      <!-- 更多信息按钮 -->
      <div class="sp44-more-wrapper">
        <div
          class="sp44-more-button"
          @click.stop="goMore"
        >
          <span class="sp44-more-text">更多&gt;&gt;</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpFourModule4',
  props: {
    componentId: {
      type: String,
      default: 'sp_four_module_4'
    },
    pageModules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 图片 div 的实际宽度，动态获取
      logoWidth: 0,
      data: {
        logoImage: 'https://image.cbrand.com.cn/default/2026/09/C0E93C36B84247FDB95C7576A077A17A.png',
        moreLink: 'https://www.cbrand.com.cn'
      }
    }
  },
  mounted() {
    this.updateLogoWidth()
    // 监听窗口尺寸变化，重新计算
    window.addEventListener('resize', this.updateLogoWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateLogoWidth)
  },
  methods: {
    // 获取 logo 容器的实际宽度
    updateLogoWidth() {
      this.$nextTick(() => {
        const el = this.$refs.logoContainer
        if (el) {
          this.logoWidth = el.offsetWidth
        }
      })
    },
    goMore() {
      if (this.data.moreLink) {
        window.open(this.data.moreLink, '_blank')
      }
    }
  }
}
</script>

<style scoped>
.sp44-wrapper {
  width: 100%;
  height: 114px;
  padding: 80px 0;
  background: #fff;
}

.sp44-section {
  width: 1400px;
  margin: 0 auto;
  position: relative;
}

/* Logo 包装器 - 固定位置 */
.sp44-logo-wrapper {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

/* Logo 图片容器 - 胶囊形 */
.sp44-logo-container {
  width: auto;
  height: 114px;
  background: linear-gradient(180deg, #CDDBFF 0%, #DDEBFF 100%);
  box-shadow: 0px 0px 10px 10px rgba(255, 255, 255, 0.7);
  border-radius: 69px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  /* 防止内部图片超出圆角 */
  overflow: hidden;
  padding: 38px;
  box-sizing: border-box;
}

/* 渐变边框 - 用伪元素实现，跟随圆角 */
.sp44-logo-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 69px;
  padding: 2px;
  background: linear-gradient(148deg, rgba(167, 146, 248, 1), rgba(167, 146, 248, 1), rgba(153, 197, 253, 1));
  -webkit-mask: 
    linear-gradient(#fff 0 0) content-box, 
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
  z-index: 1;
}

.sp44-logo-image {
  width: auto;
  height: 58px;
  box-sizing: border-box;
  position: relative;
  z-index: 2;
}

/* 横线 - 从 logo 容器右侧开始，位置和宽度由 JS 动态计算 */
.sp44-divider {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 1px;
  border: 1px solid;
  border-image: linear-gradient(297deg, rgba(174, 154, 250, 1), rgba(152, 197, 253, 1)) 1 1;
}

/* 更多按钮 - 固定在右侧 */
.sp44-more-wrapper {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
}

.sp44-more-button {
  width: 79px;
  height: 31px;
  background: linear-gradient(90deg, #CB2F30 0%, #E96E74 100%);
  box-shadow: 0px 4px 8px 1px rgba(219, 79, 81, 0.3);
  border-radius: 16px 16px 16px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sp44-more-button:hover {
  transform: scale(1.05);
  box-shadow: 0px 6px 12px 1px rgba(219, 79, 81, 0.4);
}

.sp44-more-text {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  text-align: left;
  line-height: 31px;
  white-space: nowrap;
}
</style>
